import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';

import useMainRecommendedItems from './hooks/useMainRecommendedItems';
import RecommendationItem from './RecommendationItem';
import RecommendationItemSkeletons from './RecommendationItemSkeletons';

function Recommendation() {
    const { useRecommend } = useAppCustom().main;
    const { data, isFetching } = useMainRecommendedItems();
    if (!data || data.items.length === 0 || !useRecommend) {
        return null;
    }
    return (
        <Container as='section'>
            <TitleWrapper>
                <Title size='title-lg' fontWeight='bold'>{data?.title}</Title>
            </TitleWrapper>
            <Contents >
                {data?.items.map((item) => (
                    <RecommendationItem item={item}
                        key={item.itemId} />
                ))}
                {isFetching && (
                    <RecommendationItemSkeletons/>
                )}
            </Contents>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 0 0 75px;
    row-gap: var(--spacing-3);
`;

const TitleWrapper = styled.div`
    padding: 0 var(--spacing-4);
`;

const Title = styled(Text)`
    line-height: 26px;
`;

const Contents = styled.div`
    column-gap: var(--spacing-3);
    display: flex;
    padding: 0 var(--spacing-4);
    scroll-padding: 0 var(--spacing-4);
    width: 100%;
    overflow-x: auto;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export default Recommendation;
